import {
  APPROVE_REJECT_RECORDS,
  APPROVE_REJECT_RECORDS_SUCCESS,
  APPROVE_REJECT_RECORDS_ERROR,
  APPROVE_REJECT_RECORDS_EMPTY,
} from './../../actionType.js';

const initialState = {
  data: null,
  message: null,
  loading: false,
  success: false,
  error: false,
};

const ApproveRejectRecords = (state = initialState, action) => {
  switch (action.type) {
    case APPROVE_REJECT_RECORDS:
      state = {
        ...state,
        data: null,
        loading: true,
        success: false,
        error: false,
        message: null,
      };
      break;

    case APPROVE_REJECT_RECORDS_SUCCESS:
      state = {
        ...state,
        data: action.payload,
        loading: false,
        success: true,
        error: false,
        message: null,
      };
      break;

    case APPROVE_REJECT_RECORDS_ERROR:
      state = {
        ...state,
        data: null,
        loading: false,
        success: false,
        error: true,
        message: action.payload,
      };
      break;

    case APPROVE_REJECT_RECORDS_EMPTY:
      state = {
        ...initialState,
      };
      break;

    default:
      state = { ...state };
      break;
  }
  return state;
};

export default ApproveRejectRecords;
